module.exports = __webpack_public_path__ + "static/media/line.daa52ed6.svg";